import {
    SET_STEP,
    UPDATE_ORDER,
    UPDATE_VALIDS,
    SET_ATTEMPTED,
    SET_SHIPPING_LOCATIONS,
    SET_CONCESSION_INFO,
    SET_START_FORM
} from 'Actions/form';

const initialState = {
    step: 0,
    nextAttempted: false,
    order: [],
    valids: {
        shirt: {
            type: null,
            size: null,
            colour: null,
            quantity: null
        },
        payment: {
            firstName: null,
            lastName: null,
            phone: null,
            location: true
        },
        shipping: {
            country: null,
            provinceState: null,
            city: null,
            address: null
        }
    },
    //api responses
    shippingLocations: [],
    concessionInfo: [],
    startForm: false
}

export default function form(state = initialState, action) {
    switch (action.type) {
        case SET_STEP:
            return { ...state, step: action.step };
        case UPDATE_ORDER:
            return { ...state, order: action.order };
        case UPDATE_VALIDS:
            return { ...state, valids: action.valids };
        case SET_ATTEMPTED:
            return { ...state, nextAttempted: action.toggle };
        case SET_SHIPPING_LOCATIONS:
            return { ...state, shippingLocations: action.shipping_locations };
        case SET_CONCESSION_INFO:
            return { ...state, concessionInfo: action.concession_info };
        case SET_START_FORM:
            return { ...state, startForm: action.toggle };
        default:
            return state;
    }
};